var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 13.0781C9.64844 13.0781 6.94531 10.4297 6.94531 6.19531C6.94531 5.32031 7.15625 4.07031 7.4375 3.42188C7.50781 3.24219 7.52344 3.13281 7.52344 3.05469C7.52344 2.84375 7.36719 2.60938 7.0625 2.60938C6.97656 2.60938 6.78906 2.63281 6.61719 2.69531C3.72656 3.85156 1.78906 6.96094 1.78906 10.2344C1.78906 14.8281 5.28906 18.1094 9.86719 18.1094C13.2344 18.1094 16.1484 16.0703 17.1172 13.5234C17.1875 13.3438 17.2031 13.1562 17.2031 13.0859C17.2031 12.7969 16.9609 12.6016 16.7422 12.6016C16.6406 12.6016 16.5547 12.625 16.4062 12.6719C15.8047 12.8672 14.8359 13.0781 13.875 13.0781Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.79e62e74.svg";
export { ForwardRef as ReactComponent };